export default "__VITE_ASSET__GuH5t3ku__"